import React from 'react';
import VstComponent from './VstComponent';
import classNames from 'classnames';
import copyProps from '../utils/copy-props';

class VstLilHeadListLink extends VstComponent {

  constructor() {
    super();
    this._getIcon = this._getIcon.bind(this);
  }

  _getIcon() {
    return;
  }

  render() {
    const props = copyProps(this.props, ['icon']);
    return (
      <li>
        <a {...props} className="vst-link vst-lil-head-list-link">
          <span className={classNames('link-icon', this.props.icon)} />
          <span className="link-text">{this.props.children}</span>
        </a>
      </li>
    );
  }

}

export default VstLilHeadListLink;
